// extracted by mini-css-extract-plugin
export default {"optontitle":"style-optontitle-1YVr_"};